<template>
  <div>
    <h6 class="color-darkteal">Proficient people</h6>
    <template v-for="level in levels">
      <div :key="level.level" v-if="hasProficientPeople(level.level)" class="mb-2 d-flex align-items-center">
        <div :class="[`kudo-proficient kudo-item-hex kudo-item-hex-${level.type}`]">
          <div class="kudo-item-hex kudo-item-hex-gray text-center">
            {{level.label}}
          </div>
        </div>
        <div>
          <avatar
            v-for="item in proficient[level.level]"
            :key="item.receiver.id"
            :src="item.receiver.photo"
            class="ml-2 mr-2"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Avatar from '@/components/common/Avatar'

export default {
  name: 'Proficient',

  props: {
    proficient: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      levels: [
        { level: 1, type: 'gold', label: '30+' },
        { level: 2, type: 'silver', label: '20+' },
        { level: 3, type: 'bronze', label: '10+' }
      ]
    }
  },

  methods: {
    hasProficientPeople(level) {
      return (this.proficient[level] || []).length > 0
    }
  },

  components: {
    Avatar
  }
}
</script>
